import { featuresFeature } from './feature.reducer';

const { selectFeatures, selectInitialized, selectFeaturesState } = featuresFeature;

export const FeatureSelectors = {
  selectFeaturesState,
  selectFeatures,
  selectInitialized,
};
